import { CostEstimationSearchModel } from '../../models/cost-estimation/cost-estimationSearch';
import * as CostEstimationModels from '../../models/cost-estimation/cost-estimation';
import * as Models from '../../models/commonModels';

export class GetCostEstimationList {
  static readonly type = '[CostEstimation]  GetCostEstimationList';
  constructor(public Search: CostEstimationSearchModel) { }
}

export class Refresh {
  static readonly type = '[CostEstimation] Refresh';
  constructor(public CostEstimation: CostEstimationModels.CostEstimationPreviewModel) { }
}

export class SetCostEstimation {
  static readonly type = '[CostEstimation] SetCostEstimation';
  constructor(public CostEstimation: Models.Request<CostEstimationModels.CostEstimationModel>) { }
}

export class GetCostEstimation {
  static readonly type = '[CostEstimation] SetCostEstimation';
  constructor(public CostEstimation: Models.RequestModel) { }
}

export class ServiceLineRemove {
  static readonly type = '[CostEstimation] ServiceLineRemove';
  constructor(public ServiceLine: Models.RequestModel) { }
}

export class ServiceLineAccept {
  static readonly type = '[CostEstimation] ServiceLineAccept';
  constructor(public ServiceLine: Models.RequestStateModel) { }
}

export class ServiceLineDone {
  static readonly type = '[CostEstimation] ServiceLineDone';
  constructor(public ServiceLine: Models.RequestStateModel) { }
}

export class PartLineRemove {
  static readonly type = '[CostEstimation] PartLineRemove';
  constructor(public PartLine: Models.RequestModel) { }
}

export class PartLineAccept {
  static readonly type = '[CostEstimation] PartLineAccept';
  constructor(public PartLine: Models.RequestStateModel) { }
}

export class AcceptAll {
  static readonly type = '[CostEstimation] Accept ALl';
  constructor(public CostEstimation: Models.RequestModel) { }
}

export class SetCostEstimationSearch {
  static readonly type = '[CostEstimation] SetCostEstimationSearch';
  constructor(public Search: CostEstimationSearchModel) { }
}

export class ResetCostEstimationSearch {
  static readonly type = '[CostEstimation] ResetCostEstimationSearch';
  constructor() { }
}

export class SetCostEstimationListPage {
  static readonly type = '[CostEstimation] SetCostEstimationListPage';
  constructor(public Search: CostEstimationSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[CostEstimation] DisposeSearch';
  constructor() { }
}

export class GetCostEstimationStatusDictionary {
  static readonly type = '[CostEstimation] GetCostEstimationStatusDictionary';
  constructor() { }
}

export class SetNote {
  static readonly type = '[CostEstimation] SetNote';
  constructor(public Note: Models.Request<CostEstimationModels.CostEstimationNoteModel>) { }
}

export class GetCostEstimationPDF {
  static readonly type = "[CostEstimation] Get Cost Estimation PDF";
  constructor(public Search: Models.RequestStateModel) { }
}

export class Accept {
  static readonly type = '[CostEstimation] Accept';
  constructor(public Accept: Models.RequestStateModel) { }
}

export class Cancel {
  static readonly type = '[CostEstimation] Cancel';
  constructor(public Cancel: Models.RequestStateModel) { }
} 

export class DoIt {
  static readonly type = '[CostEstimation] DoIt';
  constructor(public DoIt: Models.RequestStateModel) { }
}
